/**
 * Print / download the paper forms for a job (docs/04). Only the forms the job type needs
 * (profile jobForms) plus the Parts List. The PDF opens in a new tab, where the browser's Print
 * button prints it; every print and download is audit-logged by the server.
 */
import type { Me } from '@wo/shared';
import { Card } from './ui';

const LABELS: Record<string, string> = {
  field_report: 'Field Report',
  shop_report: 'Shop Report',
  parts_list: 'Parts List',
  lube: 'Field Lube Report',
  rental: 'Rental Check-Out / In',
};

const linkCls = 'rounded-md border border-slate-300 px-2 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-50';

export function PrintForms({ woId, me, forms }: { woId: number; me: Me; forms: string[] }) {
  const url = (form: string, q = '') => `/api/work-orders/${woId}/pdf/${form}${q}`;
  const office = me.role !== 'MECHANIC';
  // Job forms first (in profile order), then the Parts List, which every job has.
  const list = [...forms.filter((f) => f !== 'parts_list' && LABELS[f]), 'parts_list'];
  return (
    <Card title="Print forms">
      <ul className="space-y-2 text-sm">
        {list.map((form) => (
          <li key={form} className="flex flex-wrap items-center gap-2">
            <span className="mr-auto font-medium">{LABELS[form]}</span>
            <a className={linkCls} href={url(form)} target="_blank" rel="noreferrer">Print</a>
            <a className={linkCls} href={url(form, '?download=1')}>Download</a>
            {form === 'parts_list' && office && (
              <a className={linkCls} href={url(form, '?prices=0')} target="_blank" rel="noreferrer" title="Customer copy without cost, list, sell or extended">
                No prices
              </a>
            )}
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-slate-500">Opens the PDF in a new tab; use the browser&apos;s Print button.</p>
    </Card>
  );
}
